import React from 'react'
import Helmet from 'react-helmet'
import Link from 'gatsby-link'
import get from 'lodash/get'
import MapView from '../components/MapView'
import SubGallery from '../components/SubGallery'
import SearchBar from '../components/SearchBar'

class CountryTemplate extends React.Component {
  render() {
    const resource = this.props.data.markdownRemark
    const siteTitle = this.props.data.site.siteMetadata.title

    return (
      <div id="main">
        <Helmet>
          <title>{`${resource.frontmatter.title} | ${siteTitle}`} </title>
          <html lang="en" />
        </Helmet>
        <h1>{resource.frontmatter.title}</h1>
        <div className="image fit">
          <img src={'..' + resource.frontmatter.map} />
        </div>
        <div dangerouslySetInnerHTML={{ __html: resource.html }} />
        <SearchBar culture={resource.frontmatter.culture}/>
        <SubGallery
          images={resource.frontmatter.galleryitems.map(
            ({ id, link, thumb, title, alt }) => ({
              id,
              link,
              thumb,
              title,
              alt,
            })
          )}
        />
      </div>
    )
  }
}

export default CountryTemplate

export const countrPageQuery = graphql`
  query CountryByPath($path: String!) {
    site {
      siteMetadata {
        title
        author
      }
    }
    markdownRemark(frontmatter: { path: { eq: $path } }) {
      id
      html
      frontmatter {
        title
        category
        tags
        lat
        lon
        culture
        map
        galleryitems {
          id
          alt
          thumb
          link
          title
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/country.js